import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import { Subscription } from 'rxjs';
import {BaseWebservice} from '../../../../shared/base/base.webservice';
import {ProcessService} from '../../../_services/process.service';

@Component({
  selector: 'app-estate-summary',
  templateUrl: './estate-summary.component.html',
  styleUrls: ['./estate-summary.component.scss']
})
export class EstateSummaryComponent implements OnInit {

    @Input("isFinish") isFinish = false;
    private unsubscribe: Subscription[] = [];
    details:any = {};
    backupList: any;
    constructor(private router: Router, private _globalService: BaseWebservice,private processService: ProcessService) {
        this.unsubscribe.push(this._globalService.navigation$.subscribe(value => {
            if(value == 'next') {
                this.navigateToNextPage();
            }
            if(value == 'prev') {
                this.moveBack()

            }
        }))
    }



    getBackupEstate(key){
        if(key == "children") return "Their Children";
        else if (key == "beneficiary") return  "My surviving beneficiaries"
        else return   key
    }

    moveBack() {
        this.router.navigate([`/estate/${this._globalService.getContentForPage().previousPage}`])


    }

    ngOnDestroy() {
        this.unsubscribe.forEach((sb) => sb.unsubscribe());
    }
    ngOnInit(): void {
        this._globalService.setContentData()
        this.processService.getUserDetails().subscribe(response => {
            if(response['success'] == true) {
                this.details = response['data']
                // this.persons = response['data']['backup_estate_person'] ? response['data']['backup_estate_person']: []

                let backupEstates = response['data']['backup_estates'].filter(val => {
                    return val.isSelected == true // only show selected estates
                })
                let estates = response['data']['estates'].filter(val => {
                    return val.isSelected == true // only show selected estates
                })
                this.backupList = estates.map((value, index, self) => {
                    let idx = backupEstates.findIndex((t) => (
                        t.name === value.name
                    ))
                    if(index === idx) { estates[index] = backupEstates[idx] }
                    return estates[index]
                }).filter((value, index, self) =>
                    index === self.findIndex((t) => (
                        t.name === value.name
                    ))
                )

            } else {
            }
        })
        if(!this._globalService.getProcessStatus("estate")  &&!this.isFinish) {
            this.processService.setProcessStep({step: "estate"}).subscribe(response => {
                if (response['success'] == true) {


                } else {

                }
            })
        }
    }




    editProfile() {
        this.router.navigate([`/estate`])
    }

    navigateToNextPage() {
        this._globalService.appGlobalProgressStatus("estate")
        this.router.navigate([`/`])
    }
}

